import { Autocomplete } from '@mui/material';
import { styled } from '@mui/system';

const StyledAddressAutocomplete = styled(Autocomplete)({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgb(250 250 250)',
    fontSize: '14px',
  },
});

export default StyledAddressAutocomplete;
